import { useI18N, useTheme } from "@sundae/react-hooks";
import { QuestionMarkCircledIcon, Header as SundaeHeader, Tooltip } from "@sundae/ui-toolkit";
import React from "react";

import { getMenuItems } from "../../config/headerMenu";
import { HOMEPAGE_LINK_TITLE } from "../../constants/href.constants";
import { useIsWalletConnected } from "../../hooks/useIsWalletConnected";
import { useNewsBannerHeight } from "../../hooks/useNewsBannerHeight";
import { externalRoutes, paths } from "../../pages/routes";
import NewsPopover from "../NewsPopover";
import QuickMenuPopover from "../QuickMenuPopover";
import WalletButton from "../WalletButton";

const Header: React.FC = () => {
  const { t } = useI18N("header");
  const isWalletConnected = useIsWalletConnected();
  const { theme, toggleTheme } = useTheme();
  const { newsBannerHeight } = useNewsBannerHeight();

  return (
    <SundaeHeader
      homepageLinkHref={paths.root}
      homepageLinkTitle={HOMEPAGE_LINK_TITLE}
      isConnected={isWalletConnected}
      openOffCanvasLabel={t("header.menu.openOffCanvasLabel")}
      closeOffCanvasLabel={t("header.menu.closeOffCanvasLabel")}
      navigationItems={getMenuItems(isWalletConnected, t)}
      renderTertiaryNav={({ HeaderButton }) => (
        <>
          <NewsPopover />

          <Tooltip
            trigger={
              <HeaderButton onClick={() => window.open(externalRoutes.faq, "_blank")}>
                <QuestionMarkCircledIcon />
              </HeaderButton>
            }
            tooltipLabel="Visit our FAQ"
          />
          <QuickMenuPopover />
        </>
      )}
      renderWalletButton={() => <WalletButton />}
      showThemeToggle
      style={{
        marginTop: `${newsBannerHeight}px`,
      }}
      theme={theme}
      toggleTheme={toggleTheme}
    />
  );
};

export default Header;
